export default function StorePickupIcon() {
  return (
    <>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.21025 7.77136H11.2896V13.2142H12.9642V3.78564H3.53564V13.2142H5.21025V7.77136ZM6.21025 13.2142H7.74993V8.77136H6.21025V13.2142ZM8.74993 8.77136V13.2142H10.2896V8.77136H8.74993ZM2.53564 2.78564V14.2142H13.9642V2.78564H2.53564Z'
        fillOpacity='0.8'
      />
    </>
  );
}
